import { 
	persistCombineReducers,
	createTransform
} from 'redux-persist'

import createIdbStorage from '@piotr-cz/redux-persist-idb-storage'

import { reducer as FormReducer } from 'redux-form'
import AuthReducer from './auth-reducer'
import AccountReducer from './account-reducer'
import ModalReducer from './modal-reducer'

import {
	escapeRegExp
} from 'lodash'

import omit from 'fp-omit'

const entityBlackList = [
	'account.entities.activities',
	'account.entities.files',
	'account.entities.versions',
	'account.entities.sessions',
	'account.hasHardSetState',
	'account.typingUserData',
	'account.loadingHeaderTab',
	'account.entities.chats.search_results',
	'account.optimisticTodo',
	'account.optimisticChat',
	'account.keyboardHeight',
	'account.unseenNotifications',
	'account.currentTaskId',
	'account.currentProjectId',
	'account.currentProjectSlug',
	'auth.activeChats',
	'auth.chatFocusData',
	'auth.emailValidation',
	'auth.forceHideActivation',
	'auth.tempForcedUiColourState',
	'auth.referrer',
	'auth.userDataRefreshed',
	'auth.onboarded_enums',
	'auth.isBigChatOpen'
]

const entityBlackListFilter = createTransform(
	(inboundState, key) => {
		const keys = entityBlackList.map(k => k.replace(new RegExp(`^${ escapeRegExp(key) }\\.`), ''))

		return omit(inboundState, keys)
	}
)

// Outrageously slow with localForage on desktop, dunno why
const config = {
	key: 'primary',
	blacklist: ['form', 'modal', 'dashboard'],
	transforms: [ entityBlackListFilter ],
	storage: window.localForage ? window.localForage : createIdbStorage({name: 'Hassl', storeName: 'hassl_primary'}),
	serialize: false,
	deserialize: false
}

const RootReducer = persistCombineReducers(config, {
	auth: AuthReducer,
	account: AccountReducer,
	form: FormReducer,
	modal: ModalReducer,
})

export default RootReducer
